import { createAction, props } from "@ngrx/store";
import { SystemNotification } from "src/app/components/core/notification-snackbar/models/system-notification.class";

export const StartLoading = createAction('[System] Start loading');
export const StopLoading = createAction('[System] Stop loading');
export const SetNotification = createAction('[System] Set notification', props<{ notification: SystemNotification }>());
export const Redirect = createAction('[System] Redirect to', props<{ url: string }>());
export const RedirectToCourtesyPage = createAction('[System] Redirect to courtesy page');
export const RedirectToHomePage = createAction('[System] Redirect to home page');
export const Download = createAction('[System] Download file', props<{ mimeType: string, fileName: string, binary: Uint8Array | null, base64str?: string }>());
export const DownloadBlob = createAction('[System] Download blob file', props<{ mimeType: string, fileName: string, blob: Blob }>());
export const OpenPage = createAction('[System] Open Page', props<{ url: string; target?: string }>());
